module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admincolaboradores/admincolaboradores.component.scss
// module id = ./src/app/admincolaboradores/admincolaboradores.component.scss
// module chunks = main